var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-loader",class:{ 'fade-out': _vm.isloaded }},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"teste"},[_c('img',{attrs:{"src":require("../../assets/Loader/GIF-FIBRILLARE.gif"),"alt":"Loader GIF"}})])
}]

export { render, staticRenderFns }